import { get_configs, save_editor_data } from '@/pages/api/api'
import { camera_icon } from 'constant/AllIcons'
import { getAuthKey, handleEnterKeyPress } from 'constant/functions'
import { useRouter } from 'next/router'
import { useEffect, useRef, useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  fonts_name,
  font_sizes,
  font_weight,
  letter_spacing,
  text_cases,
  text_name,
} from 'constant/constant_values'
import { MultiSelect } from 'react-multi-select-component'
import { MixpanelTracking } from 'constant/mixpnael'
import Transition from '@/utils/Transition'
import CustomLoading from '@/Shared/CustomLoading'
import { useDispatch } from 'react-redux'

const Text_styles = ({ userDetails, tenantDetails }) => {
  const router = useRouter()
  const [is_open_font, setIs_open_font] = useState(null)
  const dispatch = useDispatch()

  //react  hook form
  const { register, handleSubmit, setValue, control, watch } = useForm()

  //
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdown = useRef(null)
  const trigger = useRef(null)
  let submit_type = 'save_as_draft'
  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target))
        return
      setDropdownOpen(false)
    }
    document.addEventListener('click', clickHandler)
    return () => document.removeEventListener('click', clickHandler)
  })

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return
      setDropdownOpen(false)
    }
    document.addEventListener('keydown', keyHandler)
    return
  })

  // draft styles
  const [draft_styles, set_draft_styles] = useState()

  // loading
  const [isLoading, setIsLoading] = useState(false)

  // fetching configs
  useEffect(() => {
    if (getAuthKey() === undefined) {
      router.push(`/signin?to=${site_url}${router.asPath}`)
    } else {
      get_configs(getAuthKey(), 'draft_styles').then((res) => {
        if (res?.styles) {
          res?.styles && set_draft_styles(res?.styles)

          for (let index = 0; index < text_name.length; index++) {
            const element = text_name[index]
            setValue(
              `text_styles.${element}.font_size`,
              res?.styles?.styles?.text_styles[element].font_size ||
                font_sizes[font_sizes.length - (index + 5)].value
            )
            setValue(
              `text_styles.${element}.text_case`,
              res?.styles?.styles?.text_styles[element].text_case || text_cases[0].value
            )
            setValue(
              `text_styles.${element}.font_weight`,
              res?.styles?.styles?.text_styles[element].font_weight || font_weight[0].value
            )
            setValue(
              `text_styles.${element}.letter_spacing`,
              res?.styles?.styles?.text_styles[element].letter_spacing || letter_spacing[0].value
            )
          }
        }
      })
    }
  }, [router])

  // submit data
  const onSubmit = (data, e) => {
    save_editor_data(
      'styles',
      [],
      data,
      setIsLoading,
      getAuthKey(),
      draft_styles,
      submit_type,
      router,
      undefined,
      undefined,
      undefined,
      undefined,
      dispatch
    )
  }

  return (
    <>
      {isLoading && <CustomLoading />}
      <div className="relative ">
        <div className="mb-8 ">
          {text_name.map((name) => {
            return (
              <>
                <div className="my-4 shadow bg-white p-2">
                  <p className="text-base font-medium">{name}</p>
                  <button
                    className="w-full py-2 px-3 bg-white hover:bg-gray-50 text-start text-sm"
                    onClick={() => setIs_open_font({ [name]: true })}
                  >
                    <p className="text-black">
                      {
                        font_sizes.filter(
                          ({ value }) => watch(`text_styles.${name}.font_size`) == value
                        )[0]?.title
                      }
                    </p>
                    <p className="text-black/40">{name}</p>
                  </button>
                </div>
                {is_open_font?.[name] && (
                  <div className=" fixed w-[400px] h-screen overflow-y-auto   bg-white z-30 left-0">
                    <p
                      className=" w-[400px] py-[15px] px-[25px]  border-b-2 border-primary  fixed cursor-pointer flex items-center gap-10 bg-white z-10 "
                      onClick={() => {
                        setIs_open_font(null)
                        let domain = new URL(document.getElementById('preview_iframe')?.src)
                        document.getElementById(
                          'preview_iframe'
                        ).src = `${domain.origin}/?draft=true&iframe=true`
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                      </svg>
                      <span className="">
                        <p className="text-gray-700 font-medium text-base ">
                          {
                            font_sizes.filter(
                              ({ value }) => watch(`text_styles.${name}.font_size`) == value
                            )[0]?.title
                          }
                        </p>
                        <p className="text-black/40">{name}</p>
                      </span>
                    </p>
                    <div className=" pt-20 mt-2 px-4 h-[100%]">
                      {/* forms */}
                      <form onSubmit={handleSubmit(onSubmit)} onKeyPress={handleEnterKeyPress}>
                        {/* Font Size */}
                        <div className="space-y-2 mb-6">
                          <label
                            className="block text-sm font-medium mb-1"
                            htmlFor="web_primary_font"
                          >
                            Font Size
                          </label>
                          <select
                            className="form-input w-full"
                            {...register(`text_styles.${name}.font_size`)}
                          >
                            {font_sizes?.map(({ title, value }) => {
                              return (
                                <option
                                  value={value}
                                  selected={watch(`text_styles.${name}.font_size`) == value && true}
                                >
                                  {title}
                                </option>
                              )
                            })}
                          </select>
                        </div>
                        {/* Text Case */}
                        <div className="space-y-2 mb-6">
                          <label
                            className="block text-sm font-medium mb-1"
                            htmlFor="web_primary_font"
                          >
                            Text Case
                          </label>
                          <select
                            className="form-input w-full"
                            {...register(`text_styles.${name}.text_case`)}
                          >
                            {text_cases?.map(({ title, value }) => {
                              return (
                                <option
                                  value={value}
                                  selected={watch(`text_styles.${name}.text_case`) == value && true}
                                >
                                  {title}
                                </option>
                              )
                            })}
                          </select>
                        </div>
                        {/* Font Weight */}
                        <div className="space-y-2 mb-6">
                          <label
                            className="block text-sm font-medium mb-1"
                            htmlFor="web_primary_font"
                          >
                            Font Weight
                          </label>
                          <select
                            className="form-input w-full"
                            {...register(`text_styles.${name}.font_weight`)}
                          >
                            {font_weight?.map(({ title, value }) => {
                              return (
                                <option
                                  value={value}
                                  selected={
                                    watch(`text_styles.${name}.font_weight`) == value && true
                                  }
                                >
                                  {title}
                                </option>
                              )
                            })}
                          </select>
                        </div>
                        {/* Font Weight */}
                        <div className="space-y-2 mb-6">
                          <label
                            className="block text-sm font-medium mb-1"
                            htmlFor="web_primary_font"
                          >
                            Letter Spacing
                          </label>
                          <select
                            className="form-input w-full"
                            {...register(`text_styles.${name}.letter_spacing`)}
                          >
                            {letter_spacing?.map(({ title, value }) => {
                              return (
                                <option
                                  value={value}
                                  selected={
                                    watch(`text_styles.${name}.letter_spacing`) == value && true
                                  }
                                >
                                  {title}
                                </option>
                              )
                            })}
                          </select>
                        </div>

                        {/* Buttons */}
                        <div className="  fixed  bg-white   bottom-0 left-0 w-[400px] shadow-lg   flex items-center justify-center gap-[1px] z-20">
                          <button
                            type="button"
                            className=" flex-grow"
                            onClick={() => {
                              submit_type = 'save_as_draft'
                              document.getElementById('general_submit_data').click()
                            }}
                          >
                            <a className="w-full py-[14px]  rounded-r-md bg-primary text-white ml-auto flex  flex-row items-center justify-center gap-[2px]">
                              <p className="flex  flex-col items-center justify-center gap-[2px]">
                                <span>Preview</span>
                                <span className=" text-[14px] font-[200]">
                                  It's will save as draft
                                </span>
                              </p>
                            </a>
                          </button>
                          <button
                            ref={trigger}
                            type="button"
                            aria-haspopup="true"
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            aria-expanded={dropdownOpen}
                          >
                            <a className="py-[14px] px-3 rounded-l-md   bg-primary text-white ml-auto flex items-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                stroke-width="2"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M5 15l7-7 7 7"
                                />
                              </svg>
                            </a>
                          </button>
                          <Transition
                            className="origin-bottom-right z-10 absolute bottom-full left-0  min-w-[400px] bg-white border border-gray-200  rounded shadow-lg overflow-hidden mt-1  min-h-[50px]"
                            show={dropdownOpen}
                            enter="transition ease-out duration-200 transform"
                            enterStart="opacity-0 -translate-y-2"
                            enterEnd="opacity-100 translate-y-0"
                            leave="transition ease-out duration-200"
                            leaveStart="opacity-100"
                            leaveEnd="opacity-0"
                          >
                            <div
                              ref={dropdown}
                              onFocus={() => setDropdownOpen(true)}
                              onBlur={() => setDropdownOpen(false)}
                            >
                              <ul>
                                <li>
                                  <button
                                    type="button"
                                    className="w-full"
                                    onClick={() => {
                                      submit_type = 'publish'
                                      document.getElementById('general_submit_data').click()
                                    }}
                                  >
                                    <a className="w-full  py-3 rounded-md bg-primary text-white ml-auto flex   items-center justify-center gap-[2px]">
                                      Publish
                                    </a>
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </Transition>
                        </div>
                        <input
                          id="general_submit_data"
                          type="submit"
                          value="submit"
                          className="h-0 w-0"
                        />
                      </form>
                    </div>
                  </div>
                )}
              </>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default Text_styles
